import { Injectable } from '@angular/core';
import { RoutingObserverService, RoutingInfoService } from '@routing';
import { GlobalEventBus, ActionEvents } from '@event-bus';
import { Config } from '@config';

@Injectable()
export class RouteActionsService {
    private routeActions: Array<RouteAction> = [
        {
            type: ActionEvents.tenantSaved,
            url: this.config.routeActions.tenantSaved
        },
        {
            type: ActionEvents.plantSettingsSaved,
            url: this.config.routeActions.plantSettingsSaved
        },
        {
            type: ActionEvents.tenantDeleted,
            url: this.config.routeActions.tenantDeleted
        },
        /*
        {
            type: ActionEvents.refreshPage,
            url: this.config.routeActions.plantAssigned
        },*/
        {
            type: ActionEvents.userChanged,
            url: this.config.routeActions.userChanged
        },
        {
            type: ActionEvents.passwordChanged,
            url: this.config.routeActions.passwordChanged
        },
        {
            type: ActionEvents.activatePlant,
            url: this.config.routeActions.activationChanged
        }
    ];

    constructor(
        private routingObserver: RoutingObserverService,
        private routingInfo: RoutingInfoService,
        private eventBus: GlobalEventBus,
        private config: Config
    ) {
        this.routingObserver.onRouteChanged.subscribe( async(data: any) => {
            const pathMatches = this.routeActions.filter((routeAction) => {
                return this.routingInfo.pathMatchesUrl(routeAction.url, data.url);
            });

            pathMatches.forEach((pathMatch) => {
                this.eventBus.trigger(pathMatch.type);
            });
        });
    }
}

export interface RouteAction {
    type: ActionEvents;
    url: string;
}
